import { gql } from '@apollo/client';

export default gql`
  fragment NutritionFragment on Nutrition {
    calories
    fat
    saturatedFat
    transFat
    cholesterol
    sodium
    salt
    carbohydrates
    fiber
    sugar
    proteins
    weight
    caloriesPer100
    carbohydratesPer100
    energyKJ
    energyKJPer100
    fatPer100
    proteinsPer100
    saltPer100
    saturatedFatPer100
    sugarPer100
  }
`;
